/* ブロック */
import React from 'react';
import { Container } from 'react-bootstrap';

interface Props {
  label: string;
  content: JSX.Element;
}

const Block: React.FC<Props> = ({ label, content }) => {
  return (
    <Container>
      <div className="container-box">
        <div className="heading-m">{label}</div>
        <div>{content}</div>
      </div>
    </Container>
  );
};

export default Block;
